import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const TEAM_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.PATBooster,
  PlatformSlug.INBDEBooster,
  PlatformSlug.CasperBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.CARSBooster,
  PlatformSlug.GREBooster,
  PlatformSlug.NBEOPartOne,
  PlatformSlug.DLOSCE
)

export const isTeamAvailable = (slug?: PlatformSlug) => isFeatureAvailable(TEAM_CONFIG, slug)
